import React from "react";

export default function ContactInfo() {
  return (
    <div className="contact-information">
      <div className="container">
        <div className="row">
          {/* Address */}
          <div className="col-md-4">
            <div className="contact-item wow fadeInUp" data-wow-delay="0.25s">
              <div className="contact-content">
                <div className="contact-content-title">
                  <h2>Address</h2>
                  <a
                    href="https://maps.google.com/?q=Dahisar+East+Mumbai"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Open address in Google Maps"
                  >
                    <img
                      src="/assets/images/icon-location.svg"
                      alt="Location icon"
                    />
                  </a>
                </div>

                <p>
                  Unit No.1008, Petrol Pump,
                  <br />
                  The Platina Building, Tanvi Complex,
                  <br />
                  Next to SV Road, Gaurav Tal Patriwala Industrial Area, Dahisar
                  East,
                  <br />
                  Mumbai, Maharashtra 400068
                </p>
              </div>
            </div>
          </div>

          {/* Phone */}
          <div className="col-md-4">
            <div className="contact-item wow fadeInUp" data-wow-delay="0.5s">
              <div className="contact-content">
                <div className="contact-content-title">
                  <h2>Call Now</h2>
                  <a href="tel:+918291074273" aria-label="Call us">
                    <img src="/assets/images/icon-phone.svg" alt="Phone icon" />
                  </a>
                </div>

                <p>
                  <a href="tel:+918291074273" style={{color: '#9C9FA6'}}>+91 82910 74273</a>
                </p>
              </div>
            </div>
          </div>

          {/* Email */}
          <div className="col-md-4">
            <div className="contact-item wow fadeInUp" data-wow-delay="0.75s">
              <div className="contact-content">
                <div className="contact-content-title">
                  <h2>Email Us</h2>
                  <a
                    href="mailto:onlinesales@simsonpharma.com"
                    aria-label="Send email"
                  >
                    <img src="/assets/images/icon-mail.svg" alt="Email icon" />
                  </a>
                </div>

                <p>
                  <a href="mailto:info@healthtechsl.com" style={{color: '#9C9FA6'}}>
                    info@healthtechsl.com
                  </a>
                </p>
                <p>
                  <a href="mailto:accounts@healthtechsl.com" style={{color: '#9C9FA6'}}>
                   accounts@healthtechsl.com
                  </a>
                </p>
                <p>
                  <a href="mailto:sales@healthtechsl.com" style={{color: '#9C9FA6'}}>
                   sales@healthtechsl.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
